import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { setBibTagRequest } from '../../api/controller/RaceKitController';
import { handleResponse } from '../helpers/HandleResponse';
import { Loader } from './Loader';

export const BibTagModal = ({ isOpen, toggle, raceKit, onSuccess }) => {
    const [bibTagId, setBibTagId] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isOpen && raceKit) {
            setBibTagId(raceKit.bib_tag_id || '');
            setTimeout(() => {
                const ele = document.getElementById('bibTagId');
                if (ele) {
                    // select all text if exists else just focus
                    if (ele.value) {
                        ele.select();
                    } else {
                        ele.focus();
                    }
                }
            }, 100);
        }   
    }, [isOpen, raceKit]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!raceKit) return;

        setIsLoading(true);
        try {
            const response = await setBibTagRequest({
                id: raceKit.id,
                BibTagId: bibTagId
            });
            
            handleResponse(response);
            
            // Check if the response was successful
            if (response?.Status === 'success') {
                if (onSuccess) {
                    onSuccess();
                }
                // Close modal immediately after successful save
                toggle();
            }
        } catch (error) {
            console.error('Error setting bib tag:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setBibTagId('');
        setIsLoading(false);
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose} size="sm" keyboard={false} backdrop="static">
            <Loader loading={isLoading} transparent />
            <ModalHeader toggle={handleClose}>
                Set Bib Tag - {raceKit?.bib_number}
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <FormGroup>
                        <Label for="bibTagId">Bib Tag ID</Label>
                        <Input
                            id="bibTagId"
                            type="text"
                            value={bibTagId}
                            onChange={(e) => setBibTagId(e.target.value)}
                            placeholder="Enter bib tag ID"
                            autoFocus
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button color="primary" type="submit">
                        Save
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
}; 